export default __webpack_public_path__ + "static/media/workplace.e81ca66f.png";